/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["cic",[["AM","PM"]],u,[["S","M","T","W","T","F","S"],["Nittak Holloʼ","Mantiʼ","Chostiʼ","Winstiʼ","Soistiʼ","Nannalhchifaʼ Nittak","Nittak Holloʼ Nakfish"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["Hashiʼ Ammoʼnaʼ","Hashiʼ Atokloʼ","Hashiʼ Atochchíʼnaʼ","Iiplal","Mih","Choon","Choola","Akaas","Siptimpaʼ","Aaktopaʼ","Nofimpaʼ","Tiisimpaʼ"]],u,[["BCE","CE"]],0,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"USD","$",u,{"JPY":["JP¥","¥"]},"ltr", plural];
